import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import UserInstructions from './UserInstructions';

const Faq = dynamic(() => import('./Faq'));

/**
 * `offerInstructions` deixou de ser renderizado aqui — agora aparece dentro
 * do card de autor na aba de comentários (ver OfferAuthorsCard). A aba
 * "Informações da promoção" passa a mostrar apenas FAQ e descrição do usuário.
 */
const AdditionalInfos = ({
  className,
  offerFaq,
  offerUserDescription = null,
}) => {
  if (!offerUserDescription && offerFaq.length === 0) {
    return null;
  }

  return (
    <section className={twMerge('flex-col gap-y-4 lg:mr-60', className)}>
      {offerUserDescription && (
        <UserInstructions instructions={offerUserDescription} />
      )}
      {offerFaq.length > 0 && <Faq offerFaq={offerFaq} />}
    </section>
  );
};

AdditionalInfos.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offerFaq: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ).isRequired,
  offerUserDescription: PropTypes.string,
};

export default memo(AdditionalInfos);
